import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

export const MenuButtonIcon = styled.button`
  z-index: 102;

  cursor: pointer;
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${calculateResponsiveSize(4)};
  width: ${calculateResponsiveSize(12)};
  margin-left: ${calculateResponsiveSize(24)};
  span {
    display: flex;
    width: ${calculateResponsiveSize(12)};
    height: 1px;
    background: var(--brick);
    position: relative;
  }
  &:hover span {
    background: var(--flower);
  }

  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(4)};
    width: ${calculateMobileResponsiveSize(12)};
    margin-left: ${calculateMobileResponsiveSize(24)};
    span {
      width: ${calculateMobileResponsiveSize(12)};
    }
  }
`
